export enum LocalStorageKeysEnum {
    UNIVERSIDADES = 'universidades',
    CARRERAS = 'carreras',
    USER_LOCATION = 'user_location'
};

export enum TipoUbigeoEnum {
    REGION = 'region',
    PROVINCIA = 'provincia',
    DISTRITO = 'distrito'
}

export enum TipoComunidadEnum {
    UNDEFINED = undefined,
    ESTUDIANTE = 1,
    INGRESANTE = 2,
    POSTULANTE = 3
}

export enum PeriodoAcademicoEnum {
    PERIODO_2020 = '2020',
    PERIODO_2021 = '2021',
    PERIODO_2022 = '2022',
    PERIODO_2023 = '2023',
    PERIODO_2024 = '2024',
    PERIODO_2020_1 = '2020-1',
    PERIODO_2020_2 = '2020-2',
    PERIODO_2021_1 = '2021-1',
    PERIODO_2021_2 = '2021-2',
    PERIODO_2022_1 = '2022-1',
    PERIODO_2022_2 = '2022-2',
    PERIODO_2023_1 = '2023-1',
    PERIODO_2023_2 = '2023-2',
    PERIODO_2024_1 = '2024-1',
    PERIODO_2024_2 = '2024-2',
}

export enum PeriodoAcademicoromanoEnum {
    PERIODO_2020 = '2020',
    PERIODO_2021 = '2021',
    PERIODO_2022 = '2022',
    PERIODO_2023 = '2023',
    PERIODO_2024 = '2024',
    PERIODO_2020_1 = '2020-I',
    PERIODO_2020_2 = '2020-II',
    PERIODO_2021_1 = '2021-I',
    PERIODO_2021_2 = '2021-II',
    PERIODO_2022_1 = '2022-I',
    PERIODO_2022_2 = '2022-II',
    PERIODO_2023_1 = '2023-I',
    PERIODO_2023_2 = '2023-II',
    PERIODO_2024_1 = '2024-I',
    PERIODO_2024_2 = '2024-II'
}


export enum TipoGestionEnum {
    PUBLICO = 1,
    PRIVADO = 2
}

export enum NivelAcademicoEnum {
    PREGRADO = 1,
}